module.exports = __webpack_public_path__ + "static/img/3-6.3.5.404399a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/5/3-6.3.5.png
// module id = z7vJ
// module chunks = 0